<div class="container-fluid">
  <app-task-selector *ngIf="!taskModel.hasTask()"></app-task-selector>
  <app-task-creator *ngIf="taskModel.hasTask()"></app-task-creator>
</div>
